// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_3dxgTrug07","wrapper":"OCVrwo4j84","heading":"_1Dx1Sx6dB-","knotches":"_3O7_f0qCYk","subtitle":"_25i-o3GvVW","imageSubtitle":"dCzz0PoaHw"};